import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <Link to="/" className="nav-logo">
          <div className="logo-icon">
            <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" width="42" height="42">
              <circle cx="30" cy="14" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="14" cy="42" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="46" cy="42" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="10" cy="28" r="2.5" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="50" cy="28" r="2.5" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="22" cy="50" r="2.5" stroke="#00d4d4" strokeWidth="1.5"/>
              <circle cx="38" cy="50" r="2.5" stroke="#00d4d4" strokeWidth="1.5"/>
              {/* trunk */}
              <line x1="30" y1="17" x2="30" y2="48" stroke="#00d4d4" strokeWidth="2"/>
              {/* branches */}
              <line x1="30" y1="22" x2="13" y2="40" stroke="#00d4d4" strokeWidth="1.5"/>
              <line x1="30" y1="22" x2="47" y2="40" stroke="#00d4d4" strokeWidth="1.5"/>
              <line x1="30" y1="28" x2="11" y2="28" stroke="#00d4d4" strokeWidth="1.5"/>
              <line x1="30" y1="28" x2="49" y2="28" stroke="#00d4d4" strokeWidth="1.5"/>
              <line x1="30" y1="36" x2="22" y2="48" stroke="#00d4d4" strokeWidth="1.5"/>
              <line x1="30" y1="36" x2="38" y2="48" stroke="#00d4d4" strokeWidth="1.5"/>
              {/* ground */}
              <path d="M18 52 Q30 48 42 52" stroke="#00d4d4" strokeWidth="1.5" fill="none"/>
            </svg>
          </div>
          <div className="logo-text">
            <span className="logo-name">VistaraKlyQs</span>
            <span className="logo-sub">TECH LLP</span>
          </div>
        </Link>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary nav-cta">Get Started</Link>
        </div>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
